import React, { Component } from 'react'
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { getUsername, getUserRole } from '../../../utils/functions';
import { DOCUMENT_TITLE_POSTFIX, SUPPORT_ITEMS_LIMIT } from '../../../utils/constants';
import { pushHistoryWithErrorNotFound, pushHistoryWithSignIn, urls } from '../../../utils/routing';

import UnavailablePageWrapper from '../../../containers/UnavailablePageWrapper/UnavailablePageWrapper';
import Main from '../../Main/Main';
import Back from '../../Buttons/Back/Back';
import TitleMajor from '../../TitleMajor/TitleMajor';
import LinksPanel from '../../LinksPanel/LinksPanel';
import Information from '../../Information/Information';
import MyTicket from './MyTicket/MyTicket';
import Error from '../../Error/Error';
import Toggle from '../../Toggle/Toggle';
import Paginator from '../../Paginator/Paginator';

import { TO_LANDING } from '../../../translations';

import styles from './SupportMyTickets.module.css'

const isNumberRegex = /^\d+$/;

const ticket = PropTypes.shape({
    ticketId: PropTypes.number, // this id of ticket (many sms = question and answers)
    id: PropTypes.number, // this id of main sms (question)
    problemTypes: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
    })), // array in string with support-tags
    createdAt: PropTypes.string,
        updatedAt: PropTypes.string, // time of last answer for this question
    readUser: PropTypes.bool, // read OR not read user'om
    readAgent: PropTypes.bool, // read OR not read agent'om
    role: PropTypes.string, // role of sms owner - user, moderator, admin, robot, modCreator
    isAgent: PropTypes.bool,
    isClose: PropTypes.bool,
    ownerId: PropTypes.number,
        ownerName: PropTypes.string,
    content: PropTypes.string,
    lang: PropTypes.string,
    fileOriginalName: PropTypes.string, // if this sms has download image
    fileSrc: PropTypes.string, // if this sms has download image
    fileSize: PropTypes.number, // if this sms has download image
});

export default class SupportMyTickets extends Component {
    static propTypes = {
        spaId: PropTypes.number,
        spaUsername: PropTypes.string,

        tickets: PropTypes.shape({
            isFetchedAll: PropTypes.bool,
            
            reviewed: PropTypes.number,
            answered: PropTypes.number,
            count: PropTypes.number,
            offset: PropTypes.number,
            page: PropTypes.number,
            items: PropTypes.arrayOf(ticket).isRequired, // isRequired
            /*ticket: PropTypes.shape({
                ticketId: PropTypes.number, // this id of ticket (many sms = question and answers)
                id: PropTypes.number, // this id of main sms (question)
                problemTypes: PropTypes.string, // array in string with support-tags
                createdAt: PropTypes.string,
                    updatedAt: PropTypes.string, // time of last answer for this question
                readUser: PropTypes.bool, // read OR not read user'om
                readAgent: PropTypes.bool, // read OR not read agent'om
                role: PropTypes.string, // role of sms owner - user, moderator, admin, robot, modCreator
                ownerId: PropTypes.number,
                    ownerName: PropTypes.string,
                content: PropTypes.string,
                lang: PropTypes.string,
                fileOriginalName: PropTypes.string, // if this sms has download image
                fileSize: PropTypes.number, // if this sms has download image
            }),*/
        }),

        isError: PropTypes.bool,
        isFetching: PropTypes.bool,
        isLoggedIn: PropTypes.bool.isRequired,

        fetchItemsSupportPanel: PropTypes.func.isRequired,
        onChangePage: PropTypes.func.isRequired,
        //onClickFastAnswerTicket: PropTypes.func.isRequired,
        //onClickShowOrHiddenTicket: PropTypes.func.isRequired,
        //onClickDeleteTicket: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            filterParameter: -1,
            filterOrdering: '-default',
            isFiltered: false,
        }
    }

    componentDidMount() {
        this.setDocumentTitle()

        Promise.resolve(
            this.props.onChangePage(1, this.getFilterParams(this.props)) // 1, this.getFilterParams(this.props)
        ).then(()=>{
            this.props.fetchItemsSupportPanel(this.getFilterParams(this.props))
        })
    }


    componentWillReceiveProps(nextProps) {
        //this.updateStateTickets(nextProps)
    }

    setDocumentTitle() {
        document.title = `Центр поддержки пользователей. ${DOCUMENT_TITLE_POSTFIX}`
        /*if (props.tickets.title) {
            document.title = documentTitle(props.data.title) //this.props.intl.formatMessage(messages.documentTitle, { pageTitle: props.data.title })
        }*/
    }

    getFilterParams(props) {
        //const queryStrings = queryString.parse(props.filtered.filterParams)
        const type = 1 //props.filtered.filterParams['type']//keys(queryStrings)[0]

        return {
            //argument: queryStrings[type],
            //ordering: queryStrings.ordering,
            type,
        }
    }

    handleOrderingChanged = (ordering) => {
        let filterParameter = -1;
        if (ordering === '-reports') {
            filterParameter = 0;
        } 
        
        const filterParams = {
            //...this.props.filtered.filterParams.type,
            type: filterParameter,
            ordering,
        }
        
        this.props.fetchItemsSupportPanel(filterParams)
        this.setState({filterParameter: filterParameter, filterOrdering: ordering, isFiltered: !this.state.isFiltered})
    }

    renderTickets() {
        return (
            <ul className={styles.supportWrapper}>
                {this.props.tickets.count !== 0 ? this.props.tickets.items.map((item) => this.renderTicket(item, this.state.filterParameter)) : <Error>Ничего не найдено</Error>}
            </ul>
        )
    }
    
    renderTicket = (item, type) => {
        let isOpenedTicket = false;
        if(item.ticketId === parseInt(this.props.location.pathname.slice(21, -1))) {
            isOpenedTicket = true;
        }
        
        return type === 0 ? (
            <li className={styles.support__ticket} key={`ticket-item-id-${item.id}`}>
                <MyTicket 
                    ticketId={item.ticketId} // this id of ticket (many sms = question and answers)
                    id={item.id} // this id of main sms (question)
                    modData={item.modData} // this data for reports on mod version
                    problemTypes={item.problemTypes} // array in string with support-tags
                    createdAt={item.createdAt}
                        updatedAt={item.updatedAt} // time of last answer for this question
                    readUser={item.readUser} // read OR not read user'om
                    readAgent={item.readAgent} // read OR not read agent'om
                    isAgent={item.isAgent} // agent OR user
                    isClose={item.isClose} // close OR open
                    role={item.role} // role of sms owner - user, moderator, admin, robot, modCreator
                    ownerId={item.ownerId}
                        ownerName={item.ownerName}
                    content={item.content}
                    lang={item.lang}
                    fileOriginalName={item.fileOriginalName} // if this sms has download image
                    fileSize={item.fileSize} // if this sms has download image

                    history={this.props.history}

                    isOpened={isOpenedTicket}

                    tagReport={this.state.filterParameter === -1 ? false : true}

                    onClickFastAnswerTicket={this.props.onClickFastAnswerTicket}
                    onClickShowOrHiddenTicket={this.props.onClickShowOrHiddenTicket}
                    onClickDeleteTicket={this.props.onClickDeleteTicket}
                />
            </li>
        ) : (
            <li className={styles.support__ticket} key={`ticket-item-id-${item.id}`}>
                <MyTicket 
                    ticketId={item.ticketId} // this id of ticket (many sms = question and answers)
                    id={item.id} // this id of main sms (question)
                    modData={null}
                    problemTypes={item.problemTypes} // array in string with support-tags
                    createdAt={item.createdAt}
                        updatedAt={item.updatedAt} // time of last answer for this question
                    readUser={item.readUser} // read OR not read user'om
                    readAgent={item.readAgent} // read OR not read agent'om
                    isAgent={item.isAgent} // agent OR user
                    isClose={item.isClose} // close OR open
                    role={item.role} // role of sms owner - user, moderator, admin, robot, modCreator
                    ownerId={item.ownerId}
                        ownerName={item.ownerName}
                    content={item.content}
                    lang={item.lang}
                    fileOriginalName={item.fileOriginalName} // if this sms has download image
                    fileSize={item.fileSize} // if this sms has download image

                    history={this.props.history}

                    isOpened={isOpenedTicket}

                    tagReport={this.state.filterParameter === -1 ? false : true}

                    onClickFastAnswerTicket={this.props.onClickFastAnswerTicket}
                    onClickShowOrHiddenTicket={this.props.onClickShowOrHiddenTicket}
                    onClickDeleteTicket={this.props.onClickDeleteTicket}
                />
            </li>
        )
    }

    renderFilterSupport() {
        const classNameFilter = classNames(styles.filter, {
            [styles.filter__isDisabled]: this.props.filtered.isDisabled,
        })

        return (
            <div className={classNameFilter} title="Фильтр по категориям">
                <Toggle
                    checkedItem={this.state.filterOrdering}
                    isDisabled={false} //{this.props.filtered.items.length === 0}
                    items={[
                        { // -1
                            value: "-default",
                            caption: "Поддержка"
                        },
                        { // 0
                            value: "-reports",
                            caption: "Жалоба на мод"
                        }
                    ]}
                    onItemChange={this.handleOrderingChanged}
                />
            </div>
        )
    }

    renderButtonMore() {
        return this.props.tickets.items.length === 0 && !this.props.tickets.isFetchedAll ? 
            null :
            <div></div>
    }

    renderPaginator() {
        const pages = Math.ceil(this.props.tickets.count / SUPPORT_ITEMS_LIMIT)
        
        return pages > 1 ? (
            <React.Fragment>
                <div className={styles.divider}></div>
                <div style={{position:'relative', margin:'30px 0 0', padding:'0 0 50px', textAlign:'center'}}>
                    <Paginator
                        pages={pages}
                        activePage={this.props.tickets.page}
                        onPrevPageChange={(newPage) => this.props.onChangePage(newPage, this.props.tickets.filterParams)}
                        onPageChange={(newPage) => this.props.onChangePage(newPage, this.props.tickets.filterParams)} // () => this.props.onChangePage(this.props.tickets.page, this.props.tickets.filterParams)
                    />
                </div>
            </React.Fragment>
        ) : null
    }

    renderBackButton = () => {
        return <Back caption={TO_LANDING} to={urls.landing} location={this.props.location} />
    }

    renderUrlLinker() {
        let params
        if (isNumberRegex.test( this.props.location.pathname.slice(21, -1) )) { // Number.isInteger(parseInt( this.props.location.pathname.slice(21, -1) ))
            params = this.props.location.pathname.slice(0, 21)
                .slice(1, -1)
                .split('/')
            params.push(`Тикет № ${this.props.location.pathname.slice(21, -1)}`)
        } else {
            params = this.props.location.pathname
                .slice(1, -1)
                .split('/')
        }

        return params.length > 1 ? ( <LinksPanel names={params} /> ) : null
    }

    handleLogInClick = () => {
        pushHistoryWithSignIn(this.props.history)
    }

    renderInformation() {
        return (!this.props.isLoggedIn && !this.props.isError) || this.props.isError ? (
            <Information
                message="Данный раздел недоступен"
                buttonCaption="Sign In"
                onButtonClick={this.handleLogInClick}
            />
        ) : null
    }

    renderError() {
        if (getUsername().spaId === null || getUsername().spaUsername === null) {
            return pushHistoryWithErrorNotFound(this.props.history)
        }
    }

    renderContent() {
        return this.props.isLoggedIn ? (<>
            <div className={styles.head}>
                {this.renderBackButton()}
                <TitleMajor>
                    <span></span>
                    {/* {this.renderUrlLinker()} */}
                </TitleMajor>
            </div>
            <div style={{position:'relative', marginBottom:'30px'}}><div className={styles.divider}></div></div>
            {/* {this.renderFilterSupport()} */}
            {this.renderTickets()}
            <div style={{position:'relative', marginTop:'30px'}}>
                {this.renderPaginator()}
            </div>
            </>
        ) : null
    }

    render() {
        if ((!window.__URLS__.pages.support) && (getUserRole() !== 'admin')) {
            return <UnavailablePageWrapper />
        } else {
            return (
                <Main>
                <div className={styles.base}>
                    {/* {this.renderInformation()} */}
                    {this.renderError()}
                    {this.renderContent()}
                </div>
                </Main>
            )
        }
    }
}
